import { useNavigate } from 'react-router-dom';
import type { Hizmet } from '@/mocks/hizmetler';

interface Props {
  hizmet: Hizmet;
}

export default function HizmetKart({ hizmet }: Props) {
  const navigate = useNavigate();
  const indirimOrani = Math.round(
    (1 - parseInt(hizmet.fiyat.replace(/\D/g, '')) / parseInt(hizmet.eskiFiyat.replace(/\D/g, ''))) * 100
  );

  return (
    <div
      className="rounded-2xl overflow-hidden border border-white/10 hover:border-[#E8B86D]/40 transition-all duration-300 group cursor-pointer"
      style={{ background: 'rgba(255,255,255,0.04)' }}
      onClick={() => navigate(`/hizmetler/${hizmet.slug}`)}
    >
      {/* Görsel */}
      <div className="relative overflow-hidden h-52">
        <img
          src={hizmet.gorsel}
          alt={hizmet.baslik}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#1A0F0A]/70 to-transparent" />
        <span className="absolute top-3 left-3 text-[#E8B86D] text-xs font-medium px-3 py-1 rounded-full border border-[#E8B86D]/40"
          style={{ background: 'rgba(26,15,10,0.7)', backdropFilter: 'blur(8px)' }}>
          {hizmet.kategori}
        </span>
        <span className="absolute top-3 right-3 bg-[#E8B86D] text-[#1A0F0A] text-xs font-black px-2.5 py-1 rounded-full">
          %{indirimOrani} İndirim
        </span>
      </div>

      {/* İçerik */}
      <div className="p-5">
        <h3
          className="text-lg font-black italic text-white mb-1 group-hover:text-[#E8B86D] transition-colors leading-tight"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          {hizmet.baslik}
        </h3>
        <p className="text-[#E8B86D]/70 text-xs mb-3">{hizmet.altBaslik}</p>
        <p className="text-white/50 text-sm leading-relaxed mb-4 line-clamp-2">
          {hizmet.kisaAciklama}
        </p>

        <div className="flex items-center gap-1.5 text-white/40 text-xs mb-4">
          <i className="ri-time-line text-[#E8B86D]/60"></i>
          <span>{hizmet.sure}</span>
        </div>

        <div className="flex items-center justify-between pt-4 border-t border-white/10">
          <div>
            <span className="text-white/30 text-xs line-through mr-2">{hizmet.eskiFiyat}</span>
            <span className="text-[#E8B86D] text-lg font-black">{hizmet.fiyat}</span>
          </div>
          <button className="text-[#1A0F0A] text-xs font-black px-4 py-2 rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
            style={{ background: 'linear-gradient(135deg, #C9943A, #E8B86D)' }}>
            İncele
          </button>
        </div>
      </div>
    </div>
  );
}
